import { createContext } from "react";

const context = createContext();
context.displayName = "decisions";

export default context;
